export default Object.freeze({
  'Thunderstorm': {minID: 200, maxID: 232, img: 'https://www.media.lichte.info/weather-app/assets/bg.thunderstorm.jpeg',},
  'Drizzle': {minID: 300, maxID: 321, img: 'https://www.media.lichte.info/weather-app/assets/bg.drizzle.jpeg',},
  'Rain': {minID: 500, maxID: 531, img: 'https://www.media.lichte.info/weather-app/assets/bg.rain.jpeg',},
  'Snow': {minID: 600, maxID: 622, img: 'https://www.media.lichte.info/weather-app/assets/bg.snow.jpeg',},
  'Atmosphere': {minID: 701, maxID: 781, img: 'https://www.media.lichte.info/weather-app/assets/bg.atmosphere.jpeg',},
  'Clear': {minID: 800, maxID: 800, img: 'https://www.media.lichte.info/weather-app/assets/bg.clear.jpeg',},
  'Clouds': {minID: 801, maxID: 804, img: 'https://www.media.lichte.info/weather-app/assets/bg.clouds.jpeg',},
});
